// TODO: еще подумать над кнопками, какие-то они не атомы
// eslint-disable-next-line boundaries/element-types
import { Link } from '~shared/ui/atoms/Link';

import type { CustomLinkProps } from './types';

const isInternal = (href: string): boolean => {
	return href.startsWith('/') || href.startsWith('#');
};

export const SmartLink = ({
	href,
	forceNativeLink = false,
	target,
	rel,
	prefetch,
	...rest
}: CustomLinkProps) => {
	if (isInternal(href) && !forceNativeLink) {
		return (
			<Link
				href={href}
				target={target}
				rel={rel}
				prefetch={prefetch}
				{...rest}
			/>
		);
	}
	return (
		<a
			href={href as string}
			{...rest}
			target={target ?? '_blank'}
			rel={rel ?? 'noopener noreferrer'}
		/>
	);
};
